import React, {Component} from "react";
import PropTypes from "prop-types";

export default class Accordeon extends Component {
  static propTypes = {
    label: PropTypes.string,
    children: PropTypes.element,
    className: PropTypes.string
  };
  state = {
    isOpen: false
  };
  toggle = () => {
    this.setState({
      isOpen: !this.state.isOpen
    });
  };
  render() {
    const {isOpen} = this.state;
    const {label, children, className} = this.props;
    return (
      <div className={className}>
        <button
          className={`accordeon__label${
            isOpen ? ` accordeon__label_open` : ``
          }`}
          onClick={this.toggle}
        >
          {label}
        </button>
        {isOpen && <div className="accordeon__content">{children}</div>}
      </div>
    );
  }
}
